import { useState } from "react"
import { PiMagnifyingGlassDuotone } from 'react-icons/pi'
import { FiLoader } from 'react-icons/fi'
import api from '../../../utils/api'
import useFlashMessage from '../../../hooks/useFlashMessage'
import RequiredMark from '../form/RequiredMark'

// Mesmo estilo (input + botão colado) do campo de CNPJ.
import '../CnpjSearchTrigger/CnpjSearchTrigger.css'

// Campo de CEP com botão de busca colado — consulta o ViaCEP (via backend) e devolve o
// endereço achado pro chamador preencher os campos do formulário.
// `value` é o texto exibido (já com máscara); a busca usa só os dígitos.
function CepSearchTrigger({ text, name, placeholder, value, handleOnChange, onFound, required }) {
    const [searching, setSearching] = useState(false)
    const { setFlashMessage } = useFlashMessage()

    async function search() {
        const digits = (value || '').replace(/\D/g, '')
        if (digits.length !== 8) {
            setFlashMessage('Digite um CEP válido (8 dígitos)', 'error')
            return
        }

        setSearching(true)
        const data = await api.get(`/cep/${digits}`)
            .then((response) => response.data)
            .catch((err) => err.response?.data || null)
        setSearching(false)

        // CEP único de cidade pequena vem sem logradouro — basta ter a cidade
        if (!data || !data.city) {
            setFlashMessage((data && data.message) || 'CEP não encontrado', 'error')
            return
        }

        onFound(data)
    }

    return (
        <div>
            {text && <label htmlFor={name}>{text}:{required && <RequiredMark />}</label>}
            <div className="cnpj-search-group">
                <input
                    className="input cnpj-search-input"
                    type="text"
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    value={value || ''}
                    onChange={handleOnChange}
                />
                <button type="button" className="cnpj-search-btn" title="Buscar endereço pelo CEP" onClick={search} disabled={searching}>
                    {searching
                        ? <FiLoader size={20} className="cnpj-search-spin" />
                        : <PiMagnifyingGlassDuotone size={23} />
                    }
                </button>
            </div>
        </div>
    )
}

export default CepSearchTrigger
